import axios, { AxiosInstance, AxiosResponse } from "axios";

import { ResponseRequestGeneric } from "Types/GeneralTypes";
import { hadleAxiosErrorResponse } from "helpers/handle-response";

import { showAlert } from "components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras";
import ConfigureHeaders, { RequestOptions } from "./apiClient";


export async function sendHttpRequest<T>(
    config: RequestOptions
): Promise<ResponseRequestGeneric<T>> {

    var respuesta: ResponseRequestGeneric<T> = {
        status: -1
    };

    const allConfig = ConfigureHeaders(config)

    try {
       
        const response: AxiosResponse<T> = await axios.request<T>(allConfig);

        respuesta = {
            status: response.status,
            dataResponse: response.data
        }
    } catch (error) {
        respuesta = await hadleAxiosErrorResponse<T>(error)
        if(respuesta.status === 401){
            showAlert("No está autorizado a realizar la acción",false);
        }
    }

    return respuesta
}